import Vue from "vue";
import Vuex from "vuex";
import role from "./role.module"
import user from "./user.module"
import file from "./file.module"
import artist from "./artist.module"
import album from "./album.module"
import song from "./song.module"
import songType from "./song.type.module"
import media from "./media.module"
import thumbnail from "./thumbnail.module"
import cdLink from "./cdlink.module"
import cdLinkCategory from "./cdlink.category.module"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        expandedNav: localStorage.getItem("expandedNav") === "true",
        masterKey: localStorage.getItem("masterKey"),
        loading: false,
        error: false,
        errorMsg: '',
        textLoading: false,
        textMessage: '',
        textShow: false
    },
    mutations: {
        expandNav(state, expand) {
            localStorage.setItem("expandedNav", expand);
        },
        SHOW_LOADER(state, loading) {
            state.loading = loading;
        },
        SHOW_ERROR(state, message) {
            state.error = true;
            state.errorMsg = message;
        },
        SHOW_TEXT(state, message, loading) {
            state.textLoading = loading;
            state.textMessage = message;
            state.textShow = true;
        },
        MASTER_KEY(state, masterKey) {
            if (masterKey == null) {
                localStorage.removeItem("masterKey")
            } else {
                localStorage.setItem("masterKey", masterKey);
            }
            state.masterKey = masterKey;
        }
    },
    getters: {
        isNavExpanded(state) {
            return state.expandedNav;
        }
    },
    modules: {
        role,
        user,
        file,
        artist,
        album,
        media,
        song,
        songType,
        cdLink,
        cdLinkCategory,
        thumbnail
    }
});
